import { signal } from '@preact/signals-core';

export const currentPage = signal('overview');
